/**
 * useBankrollSimulation Hook (Web)
 * Thin wrapper around shared useBankrollSimulation
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseBankrollSimulationResult,
  useBankrollSimulation as useBankrollSimulationShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseBankrollSimulationResult };

export function useBankrollSimulation(): UseBankrollSimulationResult {
  const { authFetch } = useAuth();
  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );
  return useBankrollSimulationShared({ httpClient });
}
